/**
 * 基本情報パネルコンポーネント
 *
 * 取引先の正式名称とシステム情報を表示
 */

import { Stack, Group, Text, TextInput, Divider, Button } from "@mantine/core";
import { Bot, User, Calendar, Clock, History, Trash2 } from "lucide-react";
import { Partner } from "../../services/partnerService";
import { formatTimestamp } from "../../utils/formatters";

interface BasicInfoPanelProps {
  partner: Partner;
  officialName: string;
  onOfficialNameChange: (value: string) => void;
  /** 削除ハンドラー */
  onDelete?: () => void;
}

/**
 * 基本情報パネル
 */
export function BasicInfoPanel({
  partner,
  officialName,
  onOfficialNameChange,
  onDelete,
}: BasicInfoPanelProps) {
  return (
    <Stack gap="xl" maw={600}>
      <TextInput
        label="取引先名 (正式名称)"
        placeholder="例: 株式会社ヤマエ"
        value={officialName}
        onChange={(e) => onOfficialNameChange(e.currentTarget.value)}
        required
      />

      <Divider label="システム情報" labelPosition="left" variant="dashed" />

      <Group gap={60} align="flex-start">
        <Stack gap={4}>
          <Group gap={6}>
            <History size={14} color="var(--mantine-color-gray-6)" />
            <Text size="xs" fw={700} c="dimmed">
              作成方法
            </Text>
          </Group>
          <Group gap="xs">
            {partner.source === "ai" ? (
              <Bot size={16} color="var(--mantine-color-violet-6)" />
            ) : (
              <User size={16} color="var(--mantine-color-blue-6)" />
            )}
            <Text size="sm" fw={500}>
              {partner.source === "ai" ? "AI生成" : "手動作成"}
            </Text>
          </Group>
        </Stack>

        <Stack gap={4}>
          <Group gap={6}>
            <Calendar size={14} color="var(--mantine-color-gray-6)" />
            <Text size="xs" fw={700} c="dimmed">
              作成日時
            </Text>
          </Group>
          <Text size="sm" fw={500}>
            {formatTimestamp(partner.createdAt)}
          </Text>
        </Stack>

        <Stack gap={4}>
          <Group gap={6}>
            <Clock size={14} color="var(--mantine-color-gray-6)" />
            <Text size="xs" fw={700} c="dimmed">
              最終更新日時
            </Text>
          </Group>
          <Text size="sm" fw={500}>
            {formatTimestamp(partner.updatedAt)}
          </Text>
        </Stack>
      </Group>

      {/* 削除セクション */}
      {onDelete && (
        <>
          <Divider label="危険な操作" labelPosition="left" variant="dashed" c="red" mt="xl" />
          <Button
            variant="subtle"
            color="red"
            size="xs"
            leftSection={<Trash2 size={14} />}
            onClick={onDelete}
            style={{ alignSelf: "flex-start" }}
          >
            この取引先を削除
          </Button>
        </>
      )}
    </Stack>
  );
}

